import ButtonPrimary from 'components/ButtonPrimary'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { getSubscriptionPlanUrlUtil } from 'modules/training/modules/subscription/utils/get-subscription-plan-url/index.js'

const ANALYTIC_EVENT_LABEL = {
  GET_COACHING_LANDING_PAGE: 'GET_COACHING_LANDING_PAGE'
}

const messages = defineMessages({
  getCoaching: {
    id: 'GetCoachingButton.getCoaching',
    defaultMessage: 'Get Coaching'
  }
})

export default function GetCoachingButton (props) {
  const intl = useIntl()
  const handleClickGetPremium = React.useCallback(
    () => {
      logEventAnalyticsUtil(ANALYTIC_EVENT_LABEL.GET_COACHING_LANDING_PAGE)
    },
    []
  )

  return (
    <View {...props}>
      <ButtonPrimary
        onClick={handleClickGetPremium}
        url={getSubscriptionPlanUrlUtil(SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING)}
        style={{
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {formatMessageIntlUtil(intl, messages.getCoaching)}
      </ButtonPrimary>
    </View>
  )
}
